import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";

@Injectable()
export class InReportService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  //--------------Report-----------------//
  getReport(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Report",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getClosingStock(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ClosingStock",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ClosingReport(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ClosingReport",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_StockRegister(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StockRegister",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getChequeprint(Ledger: number) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_chequeprint?Ledger=" + Ledger,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getChequeprintAmountinWords(body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_chequeprintAmoutninwords",
        body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Report-----------------//

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-report.service.ts